import type { ReactElement, SVGProps } from "react";

const SVG_PROPS = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

export function FilesChevronRightIcon(
  props: SVGProps<SVGSVGElement>
): ReactElement {
  return (
    <svg {...SVG_PROPS} strokeWidth={2} {...props}>
      <path d="M9 6l6 6-6 6" />
    </svg>
  );
}
